import Tab from '@mui/material/Tab';
import React from 'react';

interface TabProps {
  label: string;
  number?: number;
  last?: boolean;
  isSelected: boolean;
  component: React.FC;
  classes?: any;
  firstLevel?: boolean;
  onInfoIconClick?: () => void;
}

const StyledTab = (props: TabProps) => (
  <Tab
    sx={{
      textTransform: 'none',
      letterSpacing: 'normal',
      pt: 0.75,
      pr: 1.5,
      pb: 0.75,
      pl: 1.5
    }}
    disableRipple
    {...props}
  />
);

export default StyledTab;
